const initialState = [];

function usersReducer(state = initialState, action) {
  switch (action.type) {
    case "users/update":
      return action.payload;
    default:
      return state;
  }
}

export default usersReducer;
